module.exports = "/static/assets/074e6f8245cb1506deafdeac71991a5d.gif";